import React, { FC, memo, useCallback } from 'react';
import classNames from 'classnames';

import { RadioGroup } from '@zvuk-b2b/ui-kit';

import { CustomListItemProps } from '../types';

import styles from './index.module.scss';

const CustomListItem: FC<CustomListItemProps> = ({
  id,
  elementId,
  contentId,
  content,
  footer,
  isSelected,
  small = false,
  switcherHidden = false,
  onChange,
}) => {
  const handleChange = useCallback(() => {
    onChange(id);
  }, [onChange]);

  return (
    <div
      role="none"
      data-testid={`custom_list_item_container_${elementId}`}
      className={styles.container}
      onClick={handleChange}>
      <div
        id={contentId}
        className={classNames(styles.listItem, {
          [styles.listItemSelected]: isSelected,
          [styles.listItemSmall]: small,
        })}>
        {content}
        {!switcherHidden && (
          <RadioGroup
            value={isSelected ? id : null}
            onValueChange={handleChange}>
            <RadioGroup.Item
              className={classNames(styles.listItemSwitcher, {
                [styles.listItemSwitcherSmall]: small,
              })}
              value={id}
              data-testid={`custom_list_item_${id}`}
            />
          </RadioGroup>
        )}
      </div>
      {isSelected && footer}
    </div>
  );
};

export default memo(CustomListItem);
